export default __webpack_public_path__ + "static/NotAtAllConfident-b0be2ee03bf8fd4185343b1d802df613.svg";